import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/percepciones-clasificadores-de-objeto-de-gasto';

/**
 * GET Percepciones Clasificadores de Objeto de Gasto
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPercepcionesClasificadoresDeObjetoDeGasto = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Percepcion Clasificador de Objeto de Gasto
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPercepcionClasificadorDeObjetoDeGasto = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Percepcion Clasificador de Objeto de Gasto
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPercepcionClasificadorDeObjetoDeGasto = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Percepcion Clasificador de Objeto de Gasto
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPercepcionClasificadorDeObjetoDeGasto = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Percepcion Clasificador de Objeto de Gasto
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePercepcionClasificadorDeObjetoDeGasto = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
